export default function AdminPageComponent({ heading, text }) {
  return (
    <>
      <div className="flex flex-col border border-gray-300 rounded-xl">
        <div className="bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-t-xl flex justify-between">
          {heading}
        </div>

        <div className="p-3">{text}</div>
      </div>
    </>
  );
}
